export default "assets/images/texture-menu-6230a600.png";